import { refractor } from 'refractor';
import bash from 'refractor/lang/bash';
import clike from 'refractor/lang/clike';
import csharp from 'refractor/lang/csharp';
import css from 'refractor/lang/css';
import elixir from 'refractor/lang/elixir';
import erlang from 'refractor/lang/erlang';
import go from 'refractor/lang/go';
import graphql from 'refractor/lang/graphql';
import haskell from 'refractor/lang/haskell';
import java from 'refractor/lang/java';
import javascript from 'refractor/lang/javascript';
import json from 'refractor/lang/json';
import jsx from 'refractor/lang/jsx';
import kotlin from 'refractor/lang/kotlin';
import lisp from 'refractor/lang/lisp';
import markup from 'refractor/lang/markup';
import objectivec from 'refractor/lang/objectivec';
import ocaml from 'refractor/lang/ocaml';
import php from 'refractor/lang/php';
import powershell from 'refractor/lang/powershell';
import python from 'refractor/lang/python';
import ruby from 'refractor/lang/ruby';
import rust from 'refractor/lang/rust';
import scala from 'refractor/lang/scala';
import sql from 'refractor/lang/sql';
import swift from 'refractor/lang/swift';
import tsx from 'refractor/lang/tsx';
import typescript from 'refractor/lang/typescript';
import visualbasic from 'refractor/lang/visual-basic';
import yaml from 'refractor/lang/yaml';
import zig from 'refractor/lang/zig';

export const LANGUAGES = {
  none: 'None', // additional entry to disable highlighting
  bash: 'Bash',
  css: 'CSS',
  clike: 'C',
  csharp: 'C#',
  elixir: 'Elixir',
  erlang: 'Erlang',
  go: 'Go',
  graphql: 'GraphQL',
  haskell: 'Haskell',
  markup: 'HTML',
  java: 'Java',
  javascript: 'JavaScript',
  json: 'JSON',
  jsx: 'JSX',
  kotlin: 'Kotlin',
  lisp: 'Lisp',
  objectivec: 'Objective-C',
  ocaml: 'OCaml',
  php: 'PHP',
  powershell: 'Powershell',
  python: 'Python',
  ruby: 'Ruby',
  rust: 'Rust',
  scala: 'Scala',
  sql: 'SQL',
  swift: 'Swift',
  tsx: 'TSX',
  typescript: 'TypeScript',
  vb: 'Visual Basic',
  yaml: 'YAML',
  zig: 'Zig',
};

[
  bash,
  css,
  clike,
  csharp,
  elixir,
  erlang,
  go,
  graphql,
  haskell,
  java,
  javascript,
  jsx,
  json,
  kotlin,
  lisp,
  markup,
  objectivec,
  ocaml,
  php,
  python,
  powershell,
  ruby,
  rust,
  scala,
  sql,
  swift,
  typescript,
  tsx,
  visualbasic,
  yaml,
  zig,
].forEach(refractor.register);

export { refractor };
